import React, { useState } from "react";
import "./css/certificaationMarks.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CertifiedMarkImage from "./assets/certification-mark.jpg";
import PreCertifiedMarkImage from "./assets/pre-certified.jpg";

const CertificationMarks = () => {
  // ✅ Static data stored in state and sorted by order
  const [marks] = useState([
    {
      id: 31,
      section: "certification-marks",
      heading: "Certified Mark",
      url_link: null,
      content:
        "Formal symbol of assurance that a product, service, or process fully complies with the relevant Malawi standards.",
      image: CertifiedMarkImage,
      order: 14,
    },
    {
      id: 30,
      section: "certification-marks",
      heading: "Pre-certified Mark",
      url_link: null,
      content:
        "Certification issued to products or services that meet preliminary conformity assessment criteria as set in the Malawi Standards.",
      image: PreCertifiedMarkImage,
      order: 15,
    },
  ].sort((a, b) => a.order - b.order)); // ✅ sort by order ascending

  return (
    <div className="certification-marks text-center">
      <h1 className="mb-4">OUR CERTIFICATION MARKS</h1>

      <div className="row g-4 justify-content-center" style={{ padding: "20px" }}>
        {marks.length === 0 ? (
          <p className="text-muted">No certification marks available.</p>
        ) : (
          marks.map((mark) => (
            <div key={mark.id} className="col-12 col-md-6 d-flex justify-content-center">
              <div
                className="mark p-3 bg-white shadow rounded-extra mx-auto"
                style={{ maxWidth: "350px" }}
              >
                {/* Display image at default size */}
                {mark.image && (
                  <img
                    src={mark.image}
                    alt={mark.heading}
                    style={{ width: "200px", height: "150px" }}
                  />
                )}

                <center>
                  <h4
                    className="bottom-shadow mt-3 py-2"
                    style={{
                      background: "#FF6C2F",
                      borderRadius: "18px",
                      color: "white",
                      width: "220px",
                    }}
                  >
                    {mark.heading}
                  </h4>
                </center>

                <p style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400 }}>
                  {mark.content}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CertificationMarks;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "./css/certificaationMarks.css";
// import "bootstrap/dist/css/bootstrap.min.css";

// const CertificationMarks = () => {
//   const [marks, setMarks] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     axios
//       .get("http://192.168.0.5:8004/api/home-sections/certification-marks")
//       .then((response) => {
//         setMarks(response.data);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching certification marks:", error);
//         setLoading(false);
//       });
//   }, []);

//   return (
//     <div className="certification-marks text-center">
//       <h1 className="mb-4">OUR CERTIFICATION MARKS</h1>

//       <div className="row g-4 justify-content-center" style={{ padding: "20px" }}>
//         {loading ? (
//           <p className="text-muted">Loading certification marks...</p>
//         ) : marks.length === 0 ? (
//           <p className="text-muted">No certification marks available.</p>
//         ) : (
//           marks.map((mark, index) => (
//             <div key={index} className="col-12 col-md-6 d-flex justify-content-center">
//               <div
//                 className="mark p-3 bg-white shadow rounded-extra mx-auto"
//                 style={{ maxWidth: "350px" }}
//               >
//                 {/* Display image at default size */}
//                 {mark.image && (
//                   <img
//                   src={`http://192.168.0.5:8004/${mark.image}`}
//                   alt={mark.heading}
//                   style={{ width: "200px", height: "150px" }}
//                 />
                
//                 )}

//                 <center>
//                   <h4
//                     className="bottom-shadow mt-3 py-2"
//                     style={{
//                       background: "#FF6C2F",
//                       borderRadius: "18px",
//                       color: "white",
//                       width: "220px",
//                     }}
//                   >
//                     {mark.heading}
//                   </h4>
//                 </center>

//                 <p style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400 }}>
//                   {mark.content}
//                 </p>
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default CertificationMarks;
